export const GET_LAND_APPLICATIONS = '/land/get_land_application';
export const GET_SINGLE_LAND_APPLICATION = '/land/get_single_land_application';
export const CREATE_LAND_APPLICATION = '/land/create_land_application';
export const UPDATE_LAND_APPLICATION = '/land/update_land_application';

export const GET_LAND_APPRAISAL = '/land/get_land_appraisal';
export const GET_SINGLE_LAND_APPRAISAL = '/land/get_single_land_appraisal';
export const CREATE_LAND_APPRAISAL = '/land/create_land_appraisal';
export const UPDATE_LAND_APPRAISAL = '/land/update_land_appraisal';
export const REMOVE_LAND_APPRAISAL = '/land/remove_land_appraisal';

export const GET_LAND_PROPERTY_ASSESSMENT =
  '/land/get_land_property_assessment';
export const GET_SINGLE_LAND_PROPERTY_ASSESSMENT =
  '/land/get_single_land_property_assessment';
export const CREATE_LAND_PROPERTY_ASSESSMENT =
  '/land/create_land_property_assessment';
export const UPDATE_LAND_PROPERTY_ASSESSMENT =
  '/land/update_land_property_assessment';
export const REMOVE_LAND_PROPERTY_ASSESSMENT =
  '/land/remove_land_property_assessment';

export const GET_LAND_MARKET_VALUE = '/land/get_land_market_value';
export const GET_SINGLE_LAND_MARKET_VALUE =
  '/land/get_single_land_market_value';
export const CREATE_LAND_MARKET_VALUE = '/land/create_land_market_value';
export const UPDATE_LAND_MARKET_VALUE = '/land/update_land_market_value';
export const REMOVE_LAND_MARKET_VALUE = '/land/remove_land_market_value';

export const GET_LAND_RECORD_OF_SUP_ASSESSMENT =
  '/land/get_land_record_of_sup_assessment';
export const GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT =
  '/land/get_single_land_record_of_sup_assessment';
export const CREATE_LAND_RECORD_OF_SUP_ASSESSMENT =
  '/land/create_land_record_of_sup_assessment';
export const UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT =
  '/land/update_land_record_of_sup_assessment';
export const REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT =
  '/land/remove_land_record_of_sup_assessment';

export const GET_LAND_TRANSACTION = '/land/get_land_transaction';
export const GET_PAID_LAND_TRANSACTION = '/land/get_paid_land_transaction';
export const GET_SINGLE_LAND_TRANSACTION = '/land/get_single_land_transaction';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';

export const CANCEL_LAND_POSTING = '/land/cancel_land_posting';
export const POST_LAND_APPLICATION = '/land/post_land_application';

export const REVERT_LAND_APPLICATION = '/land/revert_land_application';

export const GET_ACTUAL_USES = '/get_actual_uses';

export const GET_ADJUSTMENT_FACTOR_LIST = '/land/get_assessment_level_list';

export const GET_TRANSACTION_CODES = '/get_transaction_codes';

export const GET_LAND_OWNER = '/get_land_owner';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';

export const GET_PROVINCE = 'NEW_BUSINESSES/get_provinces';
export const GET_MUNICIPALITIES = 'NEW_BUSINESSES/get_municipalities';
export const GET_BARANGAYS = 'NEW_BUSINESSES/get_barangays';
export const GET_PAYMENT_HISTORY = 'land/get_payment_history';

export const GET_PERSON_OF_CONCERN = '/get_person_of_concern';

export const GET_EFFECTIVITY_TRANSFER = '/get_effectivity_date_transfer';
export const GET_TAX_EFFECTIVITY_PERIOD = '/get_tax_effectivity_periods';

export const FAAS_URL =
  'api/v1/rpt/administrator/land/land_applications/{id}/faas';

export const FAAS_HISTORY_URL =
  '/api/v1/rpt/administrator/land/land_applications/{id}/land_history_logs/{historyId}/faas';

export const TAX_DECLARATION_URL =
  'api/v1/rpt/administrator/land/land_applications/{id}/tax_declaration';
export const TAX_DECLARATION_HISTORY_URL =
  'api/v1/rpt/administrator/land/land_applications/{id}/land_history_logs/{historyId}/tax_declaration';
export const GET_CODED_VALUE_LIST = '/get_coded_value_list';
export const GET_TDN = 'get_tdn';

export const MANUAL_POSTING = '/manual_posting';
export const GET_PIN = 'get_pin';
export const GET_LAND_SUB_CLASSIFICATIONS = 'get_land_sub_classifications';
export const GET_LOCATION_LIST = 'get_location_list';
export const GET_DISTRICTS = 'get_district_list';

export const CREATE_CHANGE_APPLICATION = 'change/land';
export const GET_SINGLE_LAND_SUB_CLASS = 'land/get_single_land_sub_class';
export const FIND_TDN = 'transfer/find_tdn';
export const GET_LOGS = '/land/get_logs';
export const GET_SUBCLASSIFICATION_LIST = '/land/get_subclassification_list';

export const RPT_LAND_GENERATE =
  'api/v1/rpt/administrator/land/land_applications/{applicationId}/transactions/{transactionId}/preview_soa';

export const FORM_DATA = {
  rptax_transaction_code_id: '',
  tdn: '',
  pin: '',
  arp_no: '',
  oct_tct_cloa_no: '',
  oct_tct_cloa_dated: '',
  registered: '',
  survey_no: '',
  lot_no: '',
  blk: '',
  rptax_owner_id: '',
  administrator_beneficial_user: '',
  administrator_beneficial_address: '',
  administrator_beneficial_telephone_no: '',
  administrator_beneficial_tin: '',
  property_province_id: 65,
  property_district_id: '',
  // property_municipality_id: '',
  property_barangay_id: '',
  property_location_id: '',
  property_street: '',
  property_boundaries_north: '',
  property_boundaries_south: '',
  property_boundaries_east: '',
  property_boundaries_west: '',
  property_boundaries_land_sketch_photo_url: '',
  effectivity_of_assessment_reassessment_yr: '',
  effectivity_of_assessment_reassessment_qtr: '',
  appraised_assessed_by: '',
  appraised_assessed_at: '',
  recommending_by: '',
  recommending_at: '',
  approved_by: '',
  approved_at: '',
  memoranda: '',
  overwrite_pin: false,
  oldPin: '',
  rptax_co_owners: [],
  appraised_assessed_by_id: '',
  recommending_by_id: '',
  approved_by_id: '',
};

export const LAND_APPRAISAL_FORM_DATA = {
  rptax_land_classification_id: '',
  rptax_land_sub_classification_id: '',
  rptax_land_buv_id: '',
  rptax_actual_use_id: '',
  area: '',
  classification: '',
  sub_classification: '',
  actual_use: '',
  rptax_land_strip_frontages: [
    {
      unit_value: 0,
    },
  ],
  type: '',
  default_strip_frontage: {
    area: 0,
    unit_value: 0,
    base_market_value: 0,
    type: null,
  },
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  actual_use: '',
  assessed_value: '',
  assessment_level: '',
  market_value: '',
  rptax_land_application_id: '',
  taxability: '',
  reason: '',
};

export const LAND_MARKET_VALUE_FORM_DATA = {
  rptax_land_adjustment_factor_id: '',
  adjustment_factor: '',
  rptax_land_appraisal_id: '',
};

export const LAND_SUP_ASSESSMENT_FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
};

export const DEFAULT_FORM = {
  code: '',
  rptax_transaction_code_id: '',
  land_application_id: '',
  oct_tct_cloa_no: '',
  registered: '',
  rptax_owner_id: '',
  tdn: '',
  tax_effectivity: '',
  tax_effectivity_year: '',
  tax_effectivity_quarter: '',

  property_district_id: '',
  property_barangay_id: '',
  property_street: '',
  property_boundaries_north: '',
  property_boundaries_south: '',
  property_boundaries_east: '',
  property_boundaries_west: '',
  property_boundaries_land_sketch_photo_url: '',
  arp_no: '',
  pin: '',
  lot_no: '',
  blk: '',
  administrator_beneficial_user: '',
  administrator_beneficial_address: '',
  administrator_beneficial_telephone_no: '',
  administrator_beneficial_tin: '',
  oct_tct_cloa_dated: '',
  survey_no: '',
  effectivity_of_assessment_reassessment_yr: '',
  effectivity_of_assessment_reassessment_qtr: '',
  appraised_assessed_at: '',
  recommending_at: '',
  approved_at: '',
  recommending_by_id: '',
  approved_by_id: '',
  appraised_assessed_by_id: '',
  overwrite_pin: 0,
};
